import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  name?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[ErrorBoundary:${this.props.name || 'unknown'}]`, error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{
          padding: '16px',
          background: '#1e1e2e',
          borderRadius: '8px',
          border: '1px solid #ef5350',
          color: '#ef5350',
          fontSize: '13px',
        }}>
          <strong>{this.props.name || 'Component'} error</strong>
          <div style={{ color: '#888', marginTop: '4px', fontSize: '12px' }}>
            {this.state.error?.message || 'Unknown error'}
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              marginTop: '8px', padding: '4px 12px', background: '#252538',
              border: '1px solid #555', borderRadius: '4px', color: '#ccc',
              cursor: 'pointer', fontSize: '12px',
            }}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
